
import Vue from 'vue'
import axios from 'axios'
import * as Sentry from '@sentry/vue'
import { Component } from 'vue-property-decorator'
import { AgencyUser, UserCommission } from '../../global/models'
import RelationshipDisplay from '../../relationships/components/RelationshipDisplay.vue'
import { consumeError } from '../../global/utils'
import ConfirmModal from '../../global/components/ConfirmModal.vue'
import { authAxios } from '@/domains/auth/utils'

@Component({
  components: { RelationshipDisplay }
})
export default class ProviderReadPage extends Vue {
  user: AgencyUser | null = null

  error: string | null = null

  userCommission: UserCommission | null = null

  get userId() {
    return this.$route.params.id
  }

  get isMe() {
    return this.userId === this.$store.state.auth.id
  }

  get disableConfirmModal() {
    return this.$refs.disableConfirmModal as ConfirmModal<AgencyUser>
  }

  get enableConfirmModal() {
    return this.$refs.enableConfirmModal as ConfirmModal<AgencyUser>
  }
  mounted() {
    this.getData()
  }

  isMigrationAgency () {
    return this.$store.getters['auth/isMigrationAgency']
  }

  userStatus() {
    return this.user?.accountStatus === 'active' ? 'Active' : 'Disabled'
  }

  async getData() {
    try {
      const response = await authAxios.get<AgencyUser>(`/accounts/${this.userId}`)
      this.user = response.data
      if (this.isMigrationAgency()) {
        const commission = await axios.get<UserCommission>(`/user-commissions/${this.userId}`)
        this.userCommission = commission.data
      }
    } catch (error: any) {
      if (error.response) {
        switch (error.response.status) {
          case 404:
            this.error = 'not-found'
            break
          case 403:
            this.error = 'unauthorised'
            break
          default:
            this.error = 'generic'
        }
      } else {
        this.error = 'generic'
      }
    }
  }

  editUser() {
    this.$router.push({ name: 'users-edit', params: { id: this.userId.toString() } })
  }

  confirmDisableUser() {
    if (!this.user) {
      return
    }
    this.disableConfirmModal.open(this.user)
  }

  confirmEnableUser() {
    if (!this.user) {
      return
    }
    this.enableConfirmModal.open(this.user)
  }

  async disableUser(user: AgencyUser) {
    try {
      await authAxios.post(`/accounts/${user.id}/disable`)
      this.getData()
    } catch (error) {
      const formattedError = consumeError(error)
      if (formattedError.code !== 'SENTRY') {
        this.$store.dispatch('error', formattedError.message)
      } else {
        Sentry.captureException(error)
      }
    }
  }

  async enableUser(user: AgencyUser) {
    try {
      await authAxios.post(`/accounts/${user.id}/activate`)
      this.getData()
    } catch (error) {
      const formattedError = consumeError(error)
      if (formattedError.code !== 'SENTRY') {
        this.$store.dispatch('error', formattedError.message)
      } else {
        Sentry.captureException(error)
      }
    }
  }
}
